import React from 'react';
import { X } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Badge } from './ui/badge';

const MenuItemModal = ({ isOpen, onClose, item, prices }) => {
  if (!item) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md mx-4 rounded-2xl">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold text-gray-900 pr-8">
            {item.name}
          </DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4">
          {/* Prix */}
          {prices && (
            <div className="flex flex-wrap gap-2">
              {prices.senior && (
                <Badge className="bg-amber-100 text-amber-800 hover:bg-amber-100 text-sm px-3 py-1">
                  Senior {prices.senior.toFixed(2)}€
                </Badge>
              )}
              {prices.mega && (
                <Badge className="bg-amber-600 text-white hover:bg-amber-600 text-sm px-3 py-1">
                  Mega {prices.mega.toFixed(2)}€
                </Badge>
              )}
              {prices.seul && (
                <Badge className="bg-amber-100 text-amber-800 hover:bg-amber-100 text-sm px-3 py-1">
                  Seul {prices.seul.toFixed(2)}€
                </Badge>
              )}
              {prices.menu && (
                <Badge className="bg-amber-600 text-white hover:bg-amber-600 text-sm px-3 py-1">
                  Menu {prices.menu.toFixed(2)}€
                </Badge>
              )}
              {prices.unique && (
                <Badge className="bg-amber-600 text-white hover:bg-amber-600 text-sm px-3 py-1">
                  {prices.unique.toFixed(2)}€
                </Badge>
              )}
            </div>
          )}
          
          {/* Composition */}
          <div className="bg-amber-50 rounded-xl p-4 border border-amber-100">
            <p className="text-sm font-semibold text-amber-700 mb-2">Composition :</p>
            <p className="text-gray-700 leading-relaxed">
              {item.composition || 'Composition non disponible.'}
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default MenuItemModal;
